import { z } from "zod";

export const UserSchema = z.object({
  id: z.string().optional(),
  firstName: z.string().min(2, {
    message: "First name must be at least 2 characters long"
  }),
  familyName: z
    .string()
    .min(3, { message: "Family name must be at least 3 characters long" }),
  username: z
    .string()
    .min(3, { message: "Username must be at least 3 characters long" }),
  password: z.string().optional(),
  email: z.string().email({ message: "Invalid email address" }),
  avatarUrl: z.string().optional()
});

export const PasswordUpdateSchema = z
  .object({
    currentPassword: z
      .string()
      .min(1, { message: "Current password is required" }),
    password: z
      .string()
      .min(8, { message: "Password must be at least 8 characters" })
      .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>]).*$/, {
        message:
          "Password must contain at least one lowercase letter, one uppercase letter, and one special character"
      }),
    confirmPassword: z.string()
  })
  .refine(data => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ["confirmPassword"]
  });

export type User = z.infer<typeof UserSchema>;
export type PasswordUpdateFormValues = z.infer<typeof PasswordUpdateSchema>;
export type NewUserPayload = z.infer<typeof UserSchema>;
